const Index = ({ color = 'none' }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.20937 1.5C5.19837 1.5 1.94681 4.74146 1.94681 8.74C1.94681 12.7385 5.19837 15.98 9.20937 15.98C13.2204 15.98 16.4719 12.7385 16.4719 8.74C16.4719 4.74146 13.2204 1.5 9.20937 1.5ZM0.442139 8.74C0.442139 3.91303 4.36736 0 9.20937 0C14.0514 0 17.9766 3.91303 17.9766 8.74C17.9766 13.567 14.0514 17.48 9.20937 17.48C4.36736 17.48 0.442139 13.567 0.442139 8.74Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5105 6.51086L6.97327 12.0309L5.9093 10.9702L11.4465 5.4502L12.5105 6.51086Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4465 12.0309L5.9093 6.51086L6.97327 5.4502L12.5105 10.9702L11.4465 12.0309Z"
        fill={color}
      />
    </svg>
  );
};

export default Index;
